export default "/assets/mm_fr.png";